import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

interface ErrorMessageContextProps {
  errorMessage: string | null;
  setErrorMessage: (message: string | null) => void;
}

const ErrorMessageContext = createContext<ErrorMessageContextProps | undefined>(
  undefined
);

export const ErrorMessageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const message = Cookies.get("x-error-message");
    if (message) {
      setErrorMessage(message);
      Cookies.remove("x-error-message", { path: "/" });
    }
  }, []);

  return (
    <ErrorMessageContext.Provider value={{ errorMessage, setErrorMessage }}>
      {children}
    </ErrorMessageContext.Provider>
  );
};

export const useErrorMessage = () => {
  const context = useContext(ErrorMessageContext);
  if (!context) {
    throw new Error(
      "useErrorMessage must be used within an ErrorMessageProvider"
    );
  }
  return context;
};
